interface ModelChangeDividerProps {
  modelLabel: string
}

export function ModelChangeDivider({ modelLabel }: ModelChangeDividerProps) {
  return (
    <div className="flex items-center gap-2 my-3 text-[11px] text-muted-foreground">
      <div className="flex-1 border-t border-dashed border-muted-foreground/30" />
      <span>Switched to <span className="font-medium">{modelLabel}</span></span>
      <div className="flex-1 border-t border-dashed border-muted-foreground/30" />
    </div>
  )
}
